(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const tracked = new Map();
  const isVideo = el => el.matches('[data-efficient-video]');
  const loadVideo = el => {
    const source = el.querySelector('source[data-src]');
    if (!source) return;
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
    el.load();
  };
  const sync = (el, visible) => {
    const active = visible && !document.hidden && !reduced.matches;
    if (!isVideo(el)) { el.classList.toggle('motion-paused', !active); return; }
    if (!active) { el.pause(); return; }
    loadVideo(el);
    el.muted = true;
    const playback = el.play();
    if (playback) playback.catch(() => {}); // Poster remains available if autoplay is blocked.
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      tracked.set(entry.target, entry.isIntersecting);
      sync(entry.target, entry.isIntersecting);
    });
  }) : null;
  const preloadObserver = observer ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || reduced.matches || document.hidden) return;
      loadVideo(entry.target);
      preloadObserver.unobserve(entry.target);
    });
  }, { rootMargin: '200px' }) : null;
  const register = (root = document) => {
    root.querySelectorAll('.announcement, .marquee, [data-efficient-video]').forEach(el => {
      if (tracked.has(el)) return;
      tracked.set(el, !observer);
      sync(el, !observer);
      observer?.observe(el);
      if (isVideo(el)) preloadObserver?.observe(el);
    });
  };
  const syncAll = () => tracked.forEach((visible, el) => sync(el, visible));
  register();
  document.addEventListener('visibilitychange', syncAll);
  reduced.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', event => register(event.target));
  document.addEventListener('shopify:section:unload', event => {
    tracked.forEach((visible, el) => {
      if (!event.target.contains(el)) return;
      if (isVideo(el)) el.pause();
      observer?.unobserve(el);
      preloadObserver?.unobserve(el);
      tracked.delete(el);
    });
  });
})();
